module.exports = __webpack_public_path__ + "static/img/app_coder2.4426aa3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/app_coder2.png
// module id = pseB
// module chunks = 5